// libs

// interfaces / constants
import { ContentItemQuery, EventFormat } from '@lopo-tech/lopo-api'
import {
  DEFAULT_AUTHOR
} from 'src/constants/meta_tags'
import { STRUCTURED_DATA_LOGO_PATH } from 'src/constants/urls'

// helper
import { UrlUtils } from 'src/utils/url/url'

export class JsonLdSchemaHelper {
  public static detailPagePost (
    contentItem: NonNullable<ContentItemQuery['contentItem']>
  ): string {
    const currentUrl = UrlUtils.currentUrlWithHostAndPath()
    // const premiumPart = meta.premiumContent
    //   ? `,"isAccessibleForFree": "False",
    //     "hasPart": {
    //       "@type": "WebPageElement",
    //       "isAccessibleForFree": "False",
    //       "cssSelector" : "${PAYWALL_CLASS}"
    //     }`
    //   : "";
    return `{
        "@context": "https://schema.org",
        "@type": "NewsArticle",
        "mainEntityOfPage": {
          "@type": "WebPage",
          "@id": "${currentUrl}"
        },
        "headline": ${
  contentItem.title ? JSON.stringify(contentItem.title) : '""'
},
        "image": [
          "${contentItem.attachments[0]?.file.previewUrl}"
         ],
        "datePublished": "${contentItem.publishedAt}",
        "author": {
          "@type": "Person",
          "name": ${JSON.stringify(contentItem.author.name)}
        },
        "publisher": {
          "@type": "Organization",
          "name": "${DEFAULT_AUTHOR}",
          "logo": {
            "@type": "ImageObject",
            "url": "${STRUCTURED_DATA_LOGO_PATH}"
          }
        },
        "description": ${
  contentItem.content.text
    ? JSON.stringify(contentItem.content.text)
    : '""'
}
      }`
  }

  public static detailPageEvent (
    contentItem: ContentItemQuery['contentItem'] & { __typename: 'Event' }
  ): string {
    const endDate = contentItem.endTime ??
      new Date(
        new Date(contentItem.startTime).getTime() + 60 * 60 * 1000
      ).toISOString()

    const diffMs = new Date(endDate).getTime() - new Date(contentItem.startTime).getTime()

    const totalMinutes = Math.floor(diffMs / 60000)
    const hours = Math.floor(totalMinutes / 60)
    const minutes = totalMinutes % 60

    const duration = `PT${hours}H${minutes}M`

    const place = {
      '@type': 'Place',
      name: contentItem.address.description ||
        [contentItem.address.street, contentItem.address.city].filter(Boolean).join(', '),
      address: {
        '@type': 'PostalAddress',
        streetAddress: contentItem.address.street,
        addressLocality: contentItem.address.city,
        postalCode: contentItem.address.zip,
        addressCountry: 'DE'
      }
    }

    const virtual = {
      '@type': 'VirtualLocation',
      url: contentItem.onlineMeetingUrl
    }

    // schema.org names three modes, and an event that is not held at its
    // address must not publish that address as its location.
    const { attendanceMode, location } =
      contentItem.format === EventFormat.Online
        ? { attendanceMode: 'OnlineEventAttendanceMode', location: virtual }
        : contentItem.format === EventFormat.Hybrid
          ? { attendanceMode: 'MixedEventAttendanceMode', location: [place, virtual] }
          : { attendanceMode: 'OfflineEventAttendanceMode', location: place }

    // The old template always wrote an image array and filled it with the string
    // "undefined" when the event had no attachment. The key belongs to events that
    // do have one, so it is conditional rather than gone.
    const preview = contentItem.attachments[0]?.file.previewUrl

    return JSON.stringify({
      '@context': 'https://schema.org',
      '@type': 'Event',
      eventStatus: 'https://schema.org/EventScheduled',
      eventAttendanceMode: `https://schema.org/${attendanceMode}`,
      name: contentItem.title ?? '',
      startDate: contentItem.startTime,
      location,
      ...(preview ? { image: [preview] } : {}),
      description: contentItem.content.text ?? '',
      endDate,
      duration
    })
  }
}
